/* Audibling meethelper (meetplan-1). Dunne laag over Shopify.analytics.publish.
 * Publiceert ALLEEN als Shopify.customerPrivacy.analyticsProcessingAllowed() true geeft.
 * Is de privacy-API er nog niet, dan blijven gebeurtenissen maximaal 10 s in het geheugen en
 * worden ze daarna weggegooid. Er wordt niets opgeslagen en er komt geen derde partij bij.
 * Nooit persoonsgegevens meesturen: geen naam, e-mail, telefoon, volledige postcode of vrije tekst.
 *
 * API
 *   abMeet(naam, data)                    gebeurtenis publiceren
 *   abMeetEenmaal(sleutel, naam, data)    hooguit eenmaal per sessie (sessionStorage)
 *   abMeetFormulierKlaar(naam, data)      publiceren en contact_posted uit de url halen
 *   abMeetSessie.get(k) / .set(k, v)      sessionStorage met try/catch
 *   abMeetQ.push([naam, data])            wachtrij, werkt ook voordat dit bestand geladen is
 */
(() => {
  if (window.abMeet && window.abMeet.__ab) return;

  const VERSIE = 'meetplan-1';
  const MAX_WACHT = 10000;
  const ctx = window.abMeetCtx || {};
  const sjabloon = [ctx.sjabloon, ctx.suffix].filter(Boolean).join('.');
  const pad = () => {
    const p = location.pathname || '/';
    return p.length > 1 ? p.replace(/\/+$/, '') : p;
  };
  const basis = () => ({ pagina: pad(), sjabloon: sjabloon, meetversie: VERSIE });
  /* doelpaden in de taal van de pagina (op /en/ met de vertaalde handle, uit layout/theme.liquid) */
  const PADEN = ctx.paden || {};
  const KAART = PADEN.kaart || '/pages/advies-aanvragen';
  const CFG = PADEN.cfg || '/pages/designlab';

  /* ---------- opslag per sessie, alleen voor vlaggen ---------- */
  const ss = {
    get: (k) => { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { window.sessionStorage.setItem(k, String(v)); } catch (e) { /* geen opslag */ } }
  };

  /* ---------- persoonsgegevens eruit halen ---------- */
  const VERBODEN_SLEUTEL = /^(naam|name|voornaam|achternaam|e-?mail|mail|telefoon|telefoonnummer|tel|phone|postcode|zip|adres|address|bericht|message|opmerking|tekst|text|q|query|zoekterm|zoekopdracht)$/i;
  const EMAIL = /[^\s@]+@[^\s@]+\.[^\s@]+/;
  const POSTCODE = /\b\d{4}\s?[a-z]{2}\b/i;
  const TELEFOON = /(\+|00)?\d[\d\s().-]{7,}\d/;
  const schoon = (data) => {
    const uit = {};
    if (!data || typeof data !== 'object') return uit;
    Object.keys(data).forEach((k) => {
      if (VERBODEN_SLEUTEL.test(k)) return;
      let v = data[k];
      if (v === undefined || typeof v === 'function') return;
      if (typeof v === 'string') {
        if (EMAIL.test(v) || POSTCODE.test(v) || TELEFOON.test(v)) return;
        v = v.slice(0, 100);
      } else if (v !== null && typeof v === 'object') {
        return; /* alleen platte waarden */
      }
      uit[k] = v;
    });
    return uit;
  };

  /* ---------- toestemming ---------- */
  const shopifyApi = () => {
    const S = window.Shopify;
    const a = S && S.analytics;
    const cp = S && S.customerPrivacy;
    if (!a || typeof a.publish !== 'function') return null;
    if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return null;
    return { a, cp };
  };
  const toegestaan = (api) => {
    try { return api.cp.analyticsProcessingAllowed() === true; } catch (e) { return false; }
  };

  /* ---------- versturen ---------- */
  let wacht = [];
  let klok = null;

  const verstuur = (api, item) => {
    try {
      api.a.publish(item.naam, item.data);
      if (item.sleutel) ss.set(item.sleutel, '1');
      return true;
    } catch (e) { return false; /* meten mag de site nooit breken */ }
  };

  const verwerkWacht = () => {
    const nu = Date.now();
    wacht = wacht.filter((it) => nu - it.t <= MAX_WACHT);
    if (!wacht.length) { stopKlok(); return; }
    const api = shopifyApi();
    if (!api) return;
    const lijst = wacht;
    wacht = [];
    stopKlok();
    if (!toegestaan(api)) return; /* geen toestemming: weggooien */
    lijst.forEach((it) => verstuur(api, it));
  };
  const stopKlok = () => { if (klok) { clearInterval(klok); klok = null; } };
  const startKlok = () => { if (!klok) klok = setInterval(verwerkWacht, 250); };

  document.addEventListener('visitorConsentCollected', () => verwerkWacht());

  const meet = (naam, data, sleutel) => {
    if (typeof naam !== 'string' || !naam) return false;
    const item = { naam: naam, data: Object.assign(basis(), schoon(data)), t: Date.now(), sleutel: sleutel || null };
    const api = shopifyApi();
    if (api) {
      if (!toegestaan(api)) return false;
      return verstuur(api, item);
    }
    if (sleutel && wacht.some((it) => it.sleutel === sleutel)) return false;
    wacht.push(item);
    startKlok();
    return true;
  };

  const abMeet = (naam, data) => meet(naam, data);
  abMeet.__ab = true;

  const abMeetEenmaal = (sleutel, naam, data) => {
    const k = 'ab-meet-' + sleutel;
    if (ss.get(k)) return false;
    return meet(naam, data, k);
  };

  const abMeetFormulierKlaar = (naam, data) => {
    const r = meet(naam, data);
    try {
      const u = new URL(location.href);
      if (u.searchParams.has('contact_posted')) {
        u.searchParams.delete('contact_posted');
        const q = u.searchParams.toString();
        history.replaceState(history.state, '', u.pathname + (q ? '?' + q : '') + u.hash);
      }
    } catch (e) { /* niets */ }
    return r;
  };

  window.abMeet = abMeet;
  window.abMeetEenmaal = abMeetEenmaal;
  window.abMeetFormulierKlaar = abMeetFormulierKlaar;
  window.abMeetSessie = ss;

  /* ---------- wachtrij van andere scripts leeglezen en daarna direct doorgeven ---------- */
  const uitQ = (r) => {
    if (!r) return;
    if (Array.isArray(r)) abMeet(r[0], r[1]);
    else if (typeof r === 'object' && r.naam) abMeet(r.naam, r.data);
  };
  const oud = Array.isArray(window.abMeetQ) ? window.abMeetQ.slice() : [];
  const q = [];
  q.push = function () { for (let i = 0; i < arguments.length; i++) uitQ(arguments[i]); return 0; };
  window.abMeetQ = q;
  oud.forEach(uitQ);

  /* ---------- gedelegeerde klikken ---------- */
  const tekst = (el) => (el.innerText || el.textContent || el.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim().slice(0, 40);
  const plek = (el) => (el.closest('.ab-header,#header-group') ? 'header' : el.closest('.ab-footer,footer') ? 'footer' : 'pagina');
  const zelfde = (u) => (u.pathname.length > 1 ? u.pathname.replace(/\/+$/, '') : u.pathname);

  document.addEventListener('click', (e) => {
    if (e.button && e.button !== 0) return;
    const a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    const href = a.getAttribute('href') || '';
    const nu = pad();

    if (/^tel:/i.test(href) || /^mailto:/i.test(href)) {
      if (a.matches('a.ab-dl__act')) return; /* de audicienkaart meet dit zelf */
      abMeet('contact_klik', { type: /^tel:/i.test(href) ? 'bellen' : 'mailen', vanaf: sjabloon, plek: plek(a) });
      return;
    }

    let u;
    try { u = new URL(href, location.href); } catch (err) { return; }
    if (u.origin !== location.origin) return;
    const doel = zelfde(u);

    if (doel === KAART && nu !== KAART) {
      abMeet('naar_audicienkaart', { vanaf: sjabloon, knoptekst: tekst(a), plek: plek(a), ontwerp_bewaard_deze_sessie: ss.get('ab-meet-pdf') === '1' });
    } else if (doel === CFG && nu !== CFG && !a.closest('[data-ab-fa]')) {
      abMeet('naar_configurator', { vanaf: sjabloon, knoptekst: tekst(a), plek: plek(a) });
    }
  }, { capture: true, passive: true });
})();
